module.exports = __webpack_public_path__ + "static/media/Pullman Avenue, Half Moon Bay, CA14.14efbcc7.jpg";